import { render, staticRenderFns } from "./LegacyModalCloseButton.vue?vue&type=template&id=44016146&scoped=true&"
import script from "./LegacyModalCloseButton.vue?vue&type=script&lang=js&"
export * from "./LegacyModalCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./LegacyModalCloseButton.vue?vue&type=style&index=0&id=44016146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44016146",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
